export const PATH = {
  PAGE_404: "/404",
  ROOT: "/",
  HOME: "/home",
  PROFILE: "/profile",
  LOGIN: "/login",
  ADMINDASH: "/admin/dashboard",
  Dashboard_CM: "/cm/dashboard",
  TS: "/ts",
  ADD_TS: "/ts/add",
  EDIT_TS: "/ts/edit",
  ADD_TS_IMAGES: "/ts/upload-images",
  SERIES_VIEW: "/series/view",
  TEST_ADD: "/test/add",
  TESTS: "/tests",
  TEST_VIEW: "/test/view",
  TEST_EDIT: "/test/edit",
  QUES_ADD: "/home/qb/add",
  QUES_ADD_V: "/home/qb/add-variant",
  QUES_BULK_ADD: "/home/qb/bulk-add",
  QUES_LIST: "/home/qb/list",
  QUES_REVIEW: "/question-bank/review",
  QUES_VIEW: "/home/qb/detail/:questionCode",
  /** Legacy bare path; same page redirects using state / localStorage */
  QUES_VIEW_BASE: "/home/qb/detail",
  QUES_VIEW_V: "/home/qb/detail_v",
  QUES_EDIT: "/home/qb/edit",
  CONTENT_MANAGER_LIST: "/cm",
  CONTENT_MANAGER_VIEW: "/cm/details",
  PAYMENT_CLAIM_REQ: "/pay/claim/req",
  SM_ADD: "/sm/add",
  SM_LIST: "/sm/list",
  SM_EDIT: "/sm/edit",
  SM_VIEW: "/sm/view",
  STORIES: "/stories",
  USERS_LIST: "/users",
  USERS_VIEW: "/user/details",
  TICKET_VIEW: "/ticket/details",
  USERS_ORDER_VIEW: "/user/order/details",
  ORDERS: "/orders",
  TEST_PREVIEW: "/exam/preview/:testid",
  RUN_TEST_PREVIEW: "/exam/preview/start/:testid",
  EXAM_REVIEW: "/exam/review",
  SC_LIST: "/sc/list",
  SC_ADD: "/sc/add",
  SC_VIEW: "/sc/view",
  SC_EDIT: "/sc/edit",
  WORK_TASK_VIEW: "/worktask/details",
  WORK_TASK_DETAILED_VIEW: "/worktask/details/detailed",
  CLAIM_REQUEST_VIEW: "/claimRequest/details",
  CM_TASKS: "/cm/tasks",
  CM_CLAIM_HISTORY: "/cm/claimHistory",
  CM_CLAIM_HISTORY_VIEW: "/cm/claimRequest/details",
  CM_FAQS_LIST: "/cm/FAQ's",
  CM_FAQ_ADD: "/cm/FAQ/add",
  CM_FAQ_VIEW: "/cm/FAQ/view",
  CM_ADD_VALIDATE_TASK: "/cm/task/view",
  CONFIG_SYSTEMS: "/config/systems",
  CONFIG_DROPDOWNS: "/config/systems/dropdowns",
  CONFIG_TESTS: "/config/tests",
  CANVAS: "/canvas",
  EXAMS_NOTIFICATIONS_LIST: "/notifications/exams/list",
  EXAMS_NOTIFICATIONS_VIEW: "/notifications/exams/view",
  ENTITIES_LIST: "/entities",
  CONTROL_BOARD: "/control-board",
  ENTITY_FILL_DETAILS: "/entity/fillDetails",
  ENTITY_VIEW_CONTENT: "/entity/viewContent",
  ENTITY_UPDATE_DETAILS: "/entity/updateDetails",
  LISTS_ENTITIES: "/lists/entities",
  LISTS_EXAMS: "/lists/exams",
  LISTS_MAPPINGS: "/lists/mappings/subjects",
  LISTS_MAPPINGS_ADD: "/lists/mappings/subjects/add",
  LISTS_MAPPINGS_VIEW: "/lists/mappings/subjects/view",
  LISTS_MAPPINGS_EDIT: "/lists/mappings/subjects/edit",
  COMPETITIONS_LIST: "/competitions",
  COMPETITION_ADD: "/competition/add",
  COMPETITION_VIEW: "/competition/view",
  COMPETITION_EDIT: "/competition/edit",
  COMPETITION_PARTICIPANT: "/competition/participant",
  WALLET_TRANSACTION: "/wallet/transaction",
  OFFERS_LIST: "/offers",
  OFFER_ADD: "/offer/add",
  OFFER_EDIT: "/offer/edit",
  OFFER_VIEW: "/offer/view",
  FAQS_LIST: "/faqs",
  FAQ_VIEW: "/faq/view",
  ISSUES_LIST: "/issues",
  ISSUE_INTERNAL_VIEW: "/issue/internal/view",
  LISTS_SUBJECTS: "/lists/subjects",
  LISTS_TOPICS: "/lists/topics",
  USERS_NOTIFICATIONS: "/notifications/users",
  CHAT_FORUMS: "/chat-forums",
  CHAT_FORUM_DETAILS: "/chat-forums/:tagId",
  MOCK_TEST_CREATOR_LIST: "/mock-test-creator",
  MOCK_TEST_CREATOR_NEW: "/mock-test-creator/new",
  MOCK_TEST_CREATOR_REVIEW: "/mock-test-creator/:jobId/review",
};

/** Question bank detail URL — use question code (e.g. Q1). */
export function quesDetailPath(questionCode) {
  if (questionCode == null || questionCode === "") return PATH.QUES_LIST;
  return `/home/qb/detail/${encodeURIComponent(String(questionCode))}`;
}
export const ToastType = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
};
